const de = {
  notFoundTitle: "Wo ist sie hin?",
  notFoundDescription: "Die Seite konnte nicht gefunden werden.",
  goHome: "Zur Startseite",
}

const en: typeof de = {
  notFoundTitle: "Where did it go?",
  notFoundDescription: "The page could not be found.",
  goHome: "Go to frontpage",
}

export const notFoundText = { de, en }
